import {darken, lighten} from '@mui/material/styles';
import theme from '../../../theme/Theme';

export const styles = () => {
  const getBackgroundColor = (color: string) =>
    (theme.palette as any).mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.9);
  const getHoverBackgroundColor = (color: string) =>
    (theme.palette as any).mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);
  return {
    root: {
      height: '100%',
      flexGrow: 1,
    },
    dataGridRoot: {
      '& .recommends-primary': {},
      '& .recommends-sub': {
        backgroundColor: getBackgroundColor(theme.palette.info.main),
        '&:hover': {
          backgroundColor: getHoverBackgroundColor(theme.palette.info.main),
        },
      },
    },
  };
};
